import * as React from 'react';

import { MainBody } from '../../layout/body/Body';
import { Greetings } from '../../components/authentication/greetings';
import { ISelectorBarTab } from '../../layout/body/selectorBar';

interface Props {
  // no longer read here - the real sidebar is layout/body/selectorBar.tsx - kept optional for
  // any caller that still constructs it rather than forcing a wider rewrite
  config?: {
    selectorBarId?: string,
    selectorBarEnabled: boolean,
    selectorBarValue: string,
    selectorBarTabs: ISelectorBarTab[]
  },
  children?: React.ReactNode
}

export const SelectorBarPage = (props: Props) => {
  const { children } = props;
  return (
    <Greetings worldAware={true}>
      <MainBody>
        {children}
      </MainBody>
    </Greetings>
  );
};
